export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12023.04563035.jpg";